// Supplement schedule - Shashank's 90-Day Fat-Loss & Muscle Plan (PDF v6).
// Daily items always show; the weekly D3 dose is filtered in by day number
// in getDayPlan(). No separate post-workout shake: dinner (tofu + toned
// milk) covers the post-workout window, so whey and creatine both move to
// pre-workout instead of the old post-workout slot.
export const SUPPLEMENTS_DAILY = [
  {
    key: 'b12',
    name: 'Vitamin B12 (Nurokind-OD)',
    dose: '1500mcg',
    time: '11:00',
    withMeal: 'midMorning',
    note: 'Correcting a deficiency; daily for ~3 months. Take ~2h apart from dairy',
  },
  {
    key: 'omega3',
    name: 'Omega-3 (algae, vegan)',
    dose: '250-500mg EPA+DHA',
    time: '13:30',
    withMeal: 'lunch',
    note: 'Recovery and joints; helps preserve muscle while cutting',
  },
  {
    key: 'whey',
    name: 'Whey (MuscleBlaze Biozyme, in water)',
    dose: '1 scoop',
    time: '17:30',
    withMeal: 'preWorkout',
    note: 'Protein taken before you lift is available right through the session',
  },
  {
    key: 'creatine',
    name: 'Creatine Monohydrate (AS-IT-IS Creapure)',
    dose: '3-5g',
    time: '17:30',
    withMeal: 'preWorkout',
    note: 'Biggest legal strength aid; take it any time daily, pre-workout is fine',
  },
]

// Vitamin D3 60,000 IU once a week, every Sunday (Day 1 = Monday, so day % 7
// === 0 lands on every 7th day: 7, 14, 21... 84).
export function getD3Dose(dayNumber) {
  return dayNumber % 7 === 0
}

export const D3_SUPPLEMENT = {
  key: 'd3',
  name: 'Vitamin D3 60K (Uprise)',
  dose: '60,000 IU',
  time: '13:30',
  withMeal: 'lunch',
  note: 'Once/week for 8 weeks, then monthly. Retest Vitamin D + B12 at week 8-9. Sundays only.',
}

// Overrides SUPPLEMENTS_DAILY/D3_SUPPLEMENT in place from a Firestore-sourced
// plan - see registerWorkoutLibrary in data/workouts.js for why this mutates
// rather than replaces the exported values (SUPPLEMENTS_DAILY is an array,
// so it's cleared and refilled rather than reassigned, same pattern
// data/foods.js's FOOD_LIST rebuild uses).
export function registerSupplementLibrary({ dailySupplements, d3Supplement }) {
  SUPPLEMENTS_DAILY.length = 0
  SUPPLEMENTS_DAILY.push(...dailySupplements)
  Object.assign(D3_SUPPLEMENT, d3Supplement)
}
